import * as React from 'react';

import { useSpeechRecognition } from '../use-speech-recognition';

interface UseBhanzuBuddyVoiceProps {
  setMessage: (message: string) => void;
}

export const useBhanzuBuddyVoice = ({
  setMessage,
}: UseBhanzuBuddyVoiceProps) => {
  const handleSpeechResult = React.useCallback(
    (transcript: string) => {
      setMessage(transcript);
    },
    [setMessage]
  );

  const { isListening, speechError, startRecognition, stopRecognition } =
    useSpeechRecognition({
      onResult: handleSpeechResult,
    });

  const handleVoiceRecord = React.useCallback(async () => {
    if (isListening) {
      stopRecognition();
    } else {
      await startRecognition();
    }
  }, [isListening, stopRecognition, startRecognition]);

  return {
    isListening,
    speechError,
    handleVoiceRecord,
  };
};
